<script>
	const { assetUrl } = require('utilities/urlUtilities');

	module.exports = {
		props: {
			isPlaying: {
				required: true,
				type: Boolean,
				default: false
			},
			onAudioClick: {
				type: Function,
				default: function () {}
			},
			reverse: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			audioIconSrc() {
				const baseUrl = `/assets/dist/images/audio${this.reverse ? '_reverse' : ''}.svg`;

				return assetUrl(baseUrl);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	.audio-player-icon {
		background: none;
		border: none;
		padding: 0;
		display: inline-flex;
		align-items: center;

		.small-icon {
			margin-top: -0.25rem;
		}
		&.is-playing {
			img.play {
				display: none;
			}
			span.pause {
				display: inline;
			}
		}
		span.pause {
			display: none;
			font-size: 1rem;
			font-weight: 100;
			line-height: 1rem;
			color: $c-slate-darker;
		}
	}
</style>
<template>
	<button
		class="audio-player-icon small-icon print-hidden"
		type="button"
		:class="{
			'is-playing': isPlaying
		}"
		aria-hidden="true"
		@click="onAudioClick()">
		<img
			class="play"
			alt="Audio"
			:src="audioIconSrc" />
		<span
			class="fa-solid fa-circle-pause small-icon pause"
			aria-hidden="true"></span>
	</button>
</template>
